import { render } from "./ColumnList.vue?vue&type=template&id=5a53b178&scoped=true"
import script from "./ColumnList.vue?vue&type=script&lang=js"
export * from "./ColumnList.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=5a53b178&lang=css&scoped=true"
import "@/assets/css/style_column.css?vue&type=style&index=1&id=5a53b178&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a53b178"]])

export default __exports__